import { render } from "./recentactivityPage.vue?vue&type=template&id=01e5e329"
import script from "./recentactivityPage.vue?vue&type=script&lang=js"
export * from "./recentactivityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__